$(document).on('click', '.menu-toggle', function () {
    $('.c2c-header nav').animate({
        right: '0'
    }, 500, 'easeInOutCubic');
  setTimeout(function(){
    $('body').toggleClass('menu-opened');
  },600);
});

$(document).on('click', '.close-menu', function () {
    $('.c2c-header nav').animate({
        right: '-100%' // Move off-screen to the right
    }, 500, 'easeInOutCubic');
  setTimeout(function(){
    $('body').toggleClass('menu-opened');
  },600);
});

$('.product-elements').each(function() {
  var $container = $(this);
  var $slider = $container.find('.image-slider .images');
  var $dotsContainer = $container.find('.product-slider-dots');

  $slider.slick({
    dots: true,
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    appendDots: $dotsContainer
  });
});

$('.c2c-youtube-video .play-button').click(function() {
  $('.c2c-youtube-video .youtube-video-overlay').hide();  
  $('.c2c-youtube-video iframe')[0].contentWindow.postMessage(
      '{"event":"command","func":"playVideo","args":""}', '*'
  );
});